module.exports = __webpack_public_path__ + "static/media/C (4).68a94b2a.jpg";